import React from 'react';

type DeleteIconProps = {
  fill?: string;
  height?: string;
  onClick?: React.MouseEventHandler<SVGElement>;
  width?: string;
};

export function DeleteIcon({
  height = '20',
  width = '18',
  onClick,
  fill = 'var(--color-gray-60)',
}: DeleteIconProps): JSX.Element {
  return (
    <svg
      data-testid='delete-icon'
      fill='none'
      height={height}
      viewBox='0 0 18 20'
      width={width}
      xmlns='http://www.w3.org/2000/svg'
      onClick={onClick}
    >
      <path
        d='M16.875 3.125H13.6328L12.3047 0.9375C11.9531 0.351562 11.3672 0 10.7031 0H6.75781C6.09375 0 5.50781 0.351562 5.15625 0.9375L3.82812 3.125H0.625C0.273438 3.125 0 3.4375 0 3.75V4.375C0 4.72656 0.273438 5 0.625 5H1.25V17.5C1.25 18.9062 2.34375 20 3.75 20H13.75C15.1172 20 16.25 18.9062 16.25 17.5V5H16.875C17.1875 5 17.5 4.72656 17.5 4.375V3.75C17.5 3.4375 17.1875 3.125 16.875 3.125ZM6.67969 1.99219C6.71875 1.95312 6.79688 1.875 6.91406 1.875H10.5859C10.6641 1.875 10.7422 1.95312 10.7812 1.99219L11.4453 3.125H6.01562L6.67969 1.99219ZM13.75 18.125H3.75C3.39844 18.125 3.125 17.8516 3.125 17.5V5H14.375V17.5C14.375 17.8516 14.0625 18.125 13.75 18.125ZM8.75 16.25C9.0625 16.25 9.375 15.9766 9.375 15.625V7.5C9.375 7.1875 9.0625 6.875 8.75 6.875C8.39844 6.875 8.125 7.1875 8.125 7.5V15.625C8.125 15.9766 8.39844 16.25 8.75 16.25ZM5.625 16.25C5.9375 16.25 6.25 15.9766 6.25 15.625V7.5C6.25 7.1875 5.9375 6.875 5.625 6.875C5.27344 6.875 5 7.1875 5 7.5V15.625C5 15.9766 5.27344 16.25 5.625 16.25ZM11.875 16.25C12.1875 16.25 12.5 15.9766 12.5 15.625V7.5C12.5 7.1875 12.1875 6.875 11.875 6.875C11.5234 6.875 11.25 7.1875 11.25 7.5V15.625C11.25 15.9766 11.5234 16.25 11.875 16.25Z'
        fill={fill}
      />
    </svg>
  );
}
